var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96097(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#fff;}.cls-2,.cls-3{fill:none;stroke:#f15c00;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-width:1.25px;}.cls-2,.cls-4{stroke-linejoin:round;}.cls-3{stroke-miterlimit:10;}.cls-4{stroke:#6e6e6e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42.17,
    cy: 47.93,
    r: 12.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 52.12,
    y1: 61.66,
    x2: 59.08,
    y2: 72.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58.91,
    y1: 50.52,
    x2: 71.54,
    y2: 53.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.43,
    y1: 38.83,
    x2: 67.34,
    y2: 31.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 24.83,
    y1: 44.36,
    x2: 12.2,
    y2: 41.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.91,
    y1: 57.04,
    x2: 17.01,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.93,
    y1: 63.56,
    x2: 35.14,
    y2: 76.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.57,
    y1: 56.1,
    x2: 62.85,
    y2: 60.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 45.88,
    y1: 71.91,
    x2: 44.94,
    y2: 64.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 28.53,
    y1: 68.17,
    x2: 32.05,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.98,
    y1: 44.26,
    x2: 58.35,
    y2: 44.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.48,
    y1: 50.72,
    x2: 17.95,
    y2: 52.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.84,
    y1: 22.49,
    x2: 33.81,
    y2: 33.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.21,
    y1: 33.73,
    x2: 28.49,
    y2: 38.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.64,
    y1: 19.63,
    x2: 45.85,
    y2: 32.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 39.76,
    y1: 30.73,
    x2: 38.81,
    y2: 23.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.46,
    y1: 34.32,
    x2: 54.98,
    y2: 27.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.28,40.83l-3.61.26c.4-6-3.69-9.62-9-9.62s-10.29,4.11-9.49,9.92L52,40.83a6.53,6.53,0,1,0,0,13.05h25.3a6.53,6.53,0,0,0,0-13.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96097);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_097.1d213b8d1166a0fef6f67c1f2a29b0a5.svg";
export { ForwardRef as ReactComponent };